import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchContent } from "../lib/api";
import { loadGA, trackPageView } from "../lib/analytics";

/**
 * App-wide Google Analytics 4 wiring for this single-page app.
 * Loads gtag.js once (using the CMS-configured GA4 Measurement ID) and sends a
 * page_view + custom spa_page_view on the initial load and every route change,
 * so /diy and every other page are counted in GA4's "Pages and screens" report.
 * No-ops silently when no GA ID is configured.
 */
export default function GAListener() {
    const location = useLocation();
    const [ready, setReady] = useState(false);

    useEffect(() => {
        let on = true;
        fetchContent()
            .then((c) => { if (on) loadGA(c?.integrations?.google_analytics_id); })
            .catch(() => {})
            .finally(() => { if (on) setReady(true); });
        return () => { on = false; };
    }, []);

    useEffect(() => {
        if (!ready) return;
        trackPageView({ path: location.pathname + location.search, title: document.title });
    }, [ready, location.pathname, location.search]);

    return null;
}
